import { Button, Icon, IconStatus, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { ManagementFeeStatus } from '../../../../../../store/rateManagement/constants';

import { ItemIcon } from './ItemIcon';

import { SentOrderListItemTypes } from '.';

export const SentOrderListItemMobile: React.FC<SentOrderListItemTypes.Props> = ({ item }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const getStatusIcon = () => {
    if (
      item.managementFeeStatusIconNormalized &&
      item.managementFeeStatusIconColorNormalized &&
      item.managementFeeStatusIconSizeNormalized &&
      item.managementFeeStatusIconBackgroundNormalized
    ) {
      return (
        <IconStatus
          icon={item.managementFeeStatusIconNormalized}
          color={item.managementFeeStatusIconColorNormalized}
          testId="header-section-status-icon"
          size={item.managementFeeStatusIconSizeNormalized}
          bgColor={item.managementFeeStatusIconBackgroundNormalized}
        />
      );
    }
  };

  const currentStatus = getStatusIcon();

  return (
    <VStack
      marginBottom={Spacing['inset.xs']}
      borderRadius={Spacing['inline.nano']}
      width={'100%'}
      justifyContent={'space-between'}
      paddingX={Spacing['inset.sm']}
      paddingY={Spacing['inset.nano']}
      background={Color['neutral.white']}>
      <HStack alignItems={'center'} py={Spacing['inset.nano']} justifyContent={'space-between'}>
        <Text fontSize={Typography['fontsize.lg']} fontWeight={Typography['fontweight.semibold']}>
          {item.managementFeeHashNormalized}
        </Text>
        <HStack alignItems={'center'}>
          {currentStatus}
          <Text
            pl={Spacing['inset.nano']}
            pr={Spacing['inset.sm']}
            fontSize={Typography['fontsize.xs']}>
            {item.managementFeeStatusTextNormalized}
          </Text>
          <ItemIcon isProcessingOrInvalid={item.isProcessing || item.isInvalid} />
        </HStack>
      </HStack>

      <VStack>
        <HStack alignItems={'center'} py={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Competência
          </Text>
          <Text fontSize={Typography['fontsize.md']}>{item.managementFeeMonthNormalized}</Text>
        </HStack>

        <HStack alignItems={'center'} py={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Tipo
          </Text>
          <Text fontSize={Typography['fontsize.md']}>{item.managementFeeTypeNormalized}</Text>
        </HStack>

        <HStack alignItems={'center'} py={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Clientes
          </Text>
          <HStack alignItems={'center'}>
            <Icon name="People" size="xs" testId="people-icon" color={Color['neutral.medium']} />
            <Text pl={2} fontSize={Typography['fontsize.md']}>
              {item.totalCustomersNormalized}
            </Text>
          </HStack>
        </HStack>

        <HStack alignItems={'center'} py={Spacing['inset.quarck']} justifyContent={'space-between'}>
          <Text color="neutral.medium" fontSize={Typography['fontsize.md']}>
            Data de envio
          </Text>
          <Text fontSize={Typography['fontsize.md']}>{item.managementFeeSentAtNormalized}</Text>
        </HStack>
      </VStack>

      <HStack alignItems={'center'} py={Spacing['inset.xs']} justifyContent={'space-between'}>
        <VStack>
          <Text pb={2} fontSize={Typography['fontsize.md']}>
            Total a receber
          </Text>
          <Text fontWeight={Typography['fontweight.semibold']} fontSize={Typography['fontsize.lg']}>
            {item.totalNormalized}
          </Text>
        </VStack>
        <Button
          backgroundColor={
            item.isProcessing ? Color['neutral.light'] : Color['brand.tertiary.principal']
          }
          isDisabled={item.isProcessing}
          onPress={() =>
            navigate('RequestDetails', { sentOrderId: item.managementFeeIdNormalized })
          }>
          {item.managementFeeStatusNormalized === ManagementFeeStatus.Processed ||
          item.managementFeeStatusNormalized === ManagementFeeStatus.Created
            ? 'CONFIRMAR'
            : 'DETALHES'}
        </Button>
      </HStack>
    </VStack>
  );
};
